import { requests } from '@/_helpers/requests'

function getMembers(organizationId) {
  return requests.get(`partner-portal/organizations/${organizationId}/members`)
}

export const organizationService = {
  getMembers,
}

export default organizationService
